var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SequencedTransition = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _animation = require("../../animation");
var _animationBuilder = require("../animationBuilder");
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return (0, _possibleConstructorReturn2.default)(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var _worklet_13585216848725_init_data = {
    code: "function anonymous(values){const{delayFunction,delay,withSequence,withTiming,reverse,config,callback}=this.__closure;return{initialValues:{originX:values.currentOriginX,originY:values.currentOriginY,width:values.currentWidth,height:values.currentHeight},animations:{originX:delayFunction(delay,withSequence(withTiming(reverse?values.currentOriginX:values.targetOriginX,config),withTiming(values.targetOriginX,config))),originY:delayFunction(delay,withSequence(withTiming(reverse?values.targetOriginY:values.currentOriginY,config),withTiming(values.targetOriginY,config))),width:delayFunction(delay,withSequence(withTiming(reverse?values.currentWidth:values.targetWidth,config),withTiming(values.targetWidth,config))),height:delayFunction(delay,withSequence(withTiming(reverse?values.targetHeight:values.currentHeight,config),withTiming(values.targetHeight,config)))},callback:callback};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultTransitions/SequencedTransition.ts",
    sourceMap: '{"version":3,"names":["anonymous","values","delayFunction","delay","withSequence","withTiming","reverse","config","callback","__closure","initialValues","originX","currentOriginX","originY","currentOriginY","width","currentWidth","height","currentHeight","animations","targetOriginX","targetOriginY","targetWidth","targetHeight"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultTransitions/SequencedTransition.ts"],"mappings":"AAqCY,SAAAA,SAAMA,CAAKC,MAAA,QAAAC,aAAA,CAAAC,KAAA,CAAAC,YAAA,CAAAC,UAAA,CAAAC,OAAA,CAAAC,MAAA,CAAAC,QAAA,OAAAC,SAAA,CAEjB,MAAO,CACLC,aAAa,CAAE,CACbC,OAAO,CAAEV,MAAM,CAACW,cAAc,CAC9BC,OAAO,CAAEZ,MAAM,CAACa,cAAc,CAC9BC,KAAK,CAAEd,MAAM,CAACe,YAAY,CAC1BC,MAAM,CAAEhB,MAAM,CAACiB,aACjB,CAAC,CACDC,UAAU,CAAE,CACVR,OAAO,CAAET,aAAa,CACpBC,KAAK,CACLC,YAAY,CACVC,UAAU,CACRC,OAAO,CAAGL,MAAM,CAACW,cAAc,CAAGX,MAAM,CAACmB,aAAa,CACtDb,MACF,CAAC,CACDF,UAAU,CAACJ,MAAM,CAACmB,aAAa,CAAEb,MAAM,CACzC,CACF,CAAC,CACDM,OAAO,CAAEX,aAAa,CACpBC,KAAK,CACLC,YAAY,CACVC,UAAU,CACRC,OAAO,CAAGL,MAAM,CAACoB,aAAa,CAAGpB,MAAM,CAACa,cAAc,CACtDP,MACF,CAAC,CACDF,UAAU,CAACJ,MAAM,CAACoB,aAAa,CAAEd,MAAM,CACzC,CACF,CAAC,CACDQ,KAAK,CAAEb,aAAa,CAClBC,KAAK,CACLC,YAAY,CACVC,UAAU,CACRC,OAAO,CAAGL,MAAM,CAACe,YAAY,CAAGf,MAAM,CAACqB,WAAW,CAClDf,MACF,CAAC,CACDF,UAAU,CAACJ,MAAM,CAACqB,WAAW,CAAEf,MAAM,CACvC,CACF,CAAC,CACDU,MAAM,CAAEf,aAAa,CACnBC,KAAK,CACLC,YAAY,CACVC,UAAU,CACRC,OAAO,CAAGL,MAAM,CAACsB,YAAY,CAAGtB,MAAM,CAACiB,aAAa,CACpDX,MACF,CAAC,CACDF,UAAU,CAACJ,MAAM,CAACsB,YAAY,CAAEhB,MAAM,CACxC,CACF,CACF,CAAC,CACDC,QAAQ,CAAEA,QACZ,CAAC,CACH"}',
    version: "3.5.4"
};
var SequencedTransition = exports.SequencedTransition = function(_BaseAnimationBuilder) {
    (0, _inherits2.default)(SequencedTransition, _BaseAnimationBuilder);
    var _super = _createSuper(SequencedTransition);
    function SequencedTransition() {
        var _this;
        (0, _classCallCheck2.default)(this, SequencedTransition);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.reversed = false;
        _this.build = function() {
            var _this$durationV;
            var delayFunction = _this.getDelayFunction();
            var callback = _this.callbackV;
            var delay = _this.getDelay();
            var sequenceDuration = ((_this$durationV = _this.durationV) != null ? _this$durationV : 500) / 2;
            var config = {
                duration: sequenceDuration
            };
            var reverse = _this.reversed;
            return function() {
                var _e = [
                    new global.Error(),
                    -8,
                    -27
                ];
                var anonymous = function anonymous(values) {
                    return {
                        initialValues: {
                            originX: values.currentOriginX,
                            originY: values.currentOriginY,
                            width: values.currentWidth,
                            height: values.currentHeight
                        },
                        animations: {
                            originX: delayFunction(delay, (0, _animation.withSequence)((0, _animation.withTiming)(reverse ? values.currentOriginX : values.targetOriginX, config), (0, _animation.withTiming)(values.targetOriginX, config))),
                            originY: delayFunction(delay, (0, _animation.withSequence)((0, _animation.withTiming)(reverse ? values.targetOriginY : values.currentOriginY, config), (0, _animation.withTiming)(values.targetOriginY, config))),
                            width: delayFunction(delay, (0, _animation.withSequence)((0, _animation.withTiming)(reverse ? values.currentWidth : values.targetWidth, config), (0, _animation.withTiming)(values.targetWidth, config))),
                            height: delayFunction(delay, (0, _animation.withSequence)((0, _animation.withTiming)(reverse ? values.targetHeight : values.currentHeight, config), (0, _animation.withTiming)(values.targetHeight, config)))
                        },
                        callback: callback
                    };
                };
                anonymous.__closure = {
                    delayFunction: delayFunction,
                    delay: delay,
                    withSequence: _animation.withSequence,
                    withTiming: _animation.withTiming,
                    reverse: reverse,
                    config: config,
                    callback: callback
                };
                anonymous.__initData = _worklet_13585216848725_init_data;
                anonymous.__workletHash = 13585216848725;
                anonymous.__stackDetails = _e;
                return anonymous;
            }();
        };
        return _this;
    }
    (0, _createClass2.default)(SequencedTransition, [
        {
            key: "reverse",
            value: function reverse() {
                this.reversed = !this.reversed;
                return this;
            }
        }
    ], [
        {
            key: "createInstance",
            value: function createInstance() {
                return new SequencedTransition();
            }
        },
        {
            key: "reverse",
            value: function reverse() {
                var instance = SequencedTransition.createInstance();
                return instance.reverse();
            }
        }
    ]);
    return SequencedTransition;
}(_animationBuilder.BaseAnimationBuilder);
